module.exports = __webpack_public_path__ + "static/media/eva_plus-circle-outline.1b067493.svg";